import { qualityListType } from "../../utils/images/imageConvertFormats";
import ImageProps, { DrawingLayerData, ImageLayerStyleData, LayerProps, TextLayerData } from "../imageStudio/images";

export const aiModelList = ['Qwen'];
export const samplerList = ['euler'];
export const schedulerList = ['simple'];
export const qualityList:qualityListType[] = ['Standard', 'HD', 'Ultra HD'];
export interface ImageCreateProps {
    imgWidth: number;
    imgHeight: number;
    numberOfGenerations: number;
    samplingSteps: number;
    cfg: number;
    model: string;
    sampler: string;
    scheduler: string;
    reference: {
        width: number;
        height: number;
    } | null
};

export interface ImageCreateResponseProps {
    // null = SL-CostsService konnte die Kosten nicht schaetzen (nicht erreichbar/nicht
    // konfiguriert) - UI muss das als "wird berechnet"/"—" zeigen, nie als 0 oder Zufallswert.
    costs: number | null;
};

export interface ImageToImageEditProps extends ImageCreateProps {
    type: 'drawing' | 'text' | 'image';
};

export interface ImageToImageEditResponseProps {
    convertToImage: number | null;
    spellCorrection: number | null;
    generateVariations: number | null;
    extractObject: number | null;
    extractPose: number | null;
    expand: number | null;
    extractAndRemove: number | null;
    removeBackground: number | null;
    removeObject: number | null;
    upscale2x: number | null;
    upscale4x: number | null;
};

export interface ImageGenerationBodyProps {
    image?: any,
    positive_prompt: string;
    negative_prompt?: string;
    width?: number;
    height?: number;
    seed?: number;
    steps?:number;
    sampler?: string;
    scheduler?: string;
    model?: string;
    cfg?:number;
    number_of_images?:number;
};
export interface ImageInpaintBodyProps {
    image?: any,
    mask?: any;
    positive_prompt: string;
    negative_prompt?: string;
    cfg?: number;
    seed?: number;
    steps?: number;
    sampler?: string;
    scheduler?: string;
    model?: string;
};

export interface AiLayerVariationGenerationProps {
    type: 'base' | 'layer';
    content: LayerProps | ImageProps;
    isMarking: boolean;
    createNewLayer: boolean;
    replaceDirectly?: boolean;
};

export interface PromptProps {
    positive_prompt: string;
    negative_prompt: string | null;
};

export interface OutPaintGenerationProps {
    image: any;
    positive_prompt: string;
    left: number;
    top: number;
    right: number;
    bottom: number;
    feathering: number;
    steps: number;
    guidance: number;
};

//DATA STORAGE
export interface DataStorageJSONImageStudio {
    layer: {
        type: 'text' | 'image' | 'drawings' | 'ai-variation';
        layerID: number;
        position: { x: number, y: number };
        width: number;
        height: number;
        orderNumber: string;
        rotation?: number;
        hidden: boolean;
        flipHorizontal?: boolean;
        flipVertical?: boolean;

        imageLayerStyle?: ImageLayerStyleData;
        textData?: TextLayerData;
        drawingData?: DrawingLayerData;
    }[];
    lastUse: Date;
    createdAt: Date;
};

export interface S3StorageListResponse {
    files: {
            key: string, // filename
            size: number,
            last_modified: Date,
            etag: string,
            content_type: any
        }[]
    ,
    total: number, //number of files in storage
    bucket: string
};

export interface UpscaleCostProps {
    // null = noch nicht bepreist (siehe ImageCreateResponseProps) - nie als 0 anzeigen.
    upscale2x: number | null;
    upscale4x: number | null;
};